import { Component, inject } from '@angular/core';

import { MessageService } from '../../services/message.service';

@Component({
  selector: 'app-flash-message',
  standalone: true,
  templateUrl: './flash-message.component.html',
  styleUrl: './flash-message.component.scss',
})
export class FlashMessageComponent {
  protected readonly messageService = inject(MessageService);
}
